import React from 'react';
import SimpleInfoModal from './SimpleInfoModal';
import Terms from '../../../common/Terms';

const TermsModal = (props) => {
    return (
        <SimpleInfoModal
            {...props}
            title="이용약관"
            maxWidth="max-w-md"
        >
            <Terms />
        </SimpleInfoModal>
    );
};

export default TermsModal;